import React, { useEffect, useRef } from "react";
import { Button } from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useDispatch, useSelector } from "react-redux";
import MessageBubble from "./MessageBubble";
import QuickQuestions from "./QuickQuestions";
import SampleFileCard from "./SampleFileCard";
import TicketForm from "./TicketForm";
import TicketStatusCard from "./TicketStatusCard";
import { showQuickQuestions } from "../../store/actions/chatbot";

function MessageList() {
  const dispatch = useDispatch();
  const messages = useSelector((s) => s.chatbot.messages);
  const showQQ = useSelector((s) => s.chatbot.showQuickQuestions);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleTicketSubmitted = (ticketId) => {
    // No further action needed — TicketForm shows its own confirmation
  };

  return (
    <div className="chat-message-list">
      {/* Greeting */}
      <div className="chat-bubble-wrapper chat-bubble-wrapper--assistant">
        <div className="chat-bubble chat-bubble--assistant">
          Hi! I'm your Aye Salon assistant. Pick a question below or type your query.
        </div>
      </div>

      {/* Quick questions shown at start or when user requests them */}
      {showQQ && <QuickQuestions />}

      {/* Show questions again button — always visible after first message */}
      {messages.length > 0 && !showQQ && (
        <div style={{ display: "flex", justifyContent: "center", margin: "8px 0" }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<FormatListBulletedIcon />}
            onClick={() => dispatch(showQuickQuestions())}
            sx={{ textTransform: "none", fontSize: "12px", borderRadius: "20px" }}
          >
            Show questions again
          </Button>
        </div>
      )}

      {/* Message history */}
      {messages.map((msg, idx) => (
        <React.Fragment key={idx}>
          {/* Skip the text bubble for CHECK_TICKET — the card below shows everything */}
          {msg.action !== "CHECK_TICKET" && <MessageBubble message={msg} />}
          {msg.action === "RAISE_TICKET" && (
            <TicketForm onSubmitted={handleTicketSubmitted} />
          )}
          {msg.action === "CHECK_TICKET" && (
            <TicketStatusCard ticketId={msg.ticket_id} />
          )}
          {msg.action === "TICKET_CREATED" && (
            <TicketStatusCard ticketId={msg.ticket_id} showSuccessBadge />
          )}
          {msg.action === "SAMPLE_FILE_CLIENTS" && <SampleFileCard type="clients" />}
          {msg.action === "SAMPLE_FILE_SERVICES" && <SampleFileCard type="services" />}
        </React.Fragment>
      ))}

      <div ref={bottomRef} />
    </div>
  );
}

export default MessageList;
